<template>
  <b-list-group
    class="survey attendees__list"
    :class="column ? 'flex-row flex-wrap' : ''"
  >
    <b-list-group-item
      v-for="attendee in attendees"
      :key="attendee.userId"
      :class="[
        borderClassByRole(attendee),
        column ? 'col-12 col-md-6 col-lg-4' : '',
      ]"
      class="mr-0 survey-person attendees__attendee"
      :button="checkAction"
      @click="checkAction ? toggleAttending(attendee.userId) : null"
      :disabled="attendee.actionInProgress"
    >
      <div class="company">
        <img
          v-if="attendee.organizationLogo"
          :src="attendee.organizationLogo"
          class="logo img-fluid"
          alt="Respondent Organiztion Logo"
        />
      </div>
      <div class="person">
        <p class="name">{{ attendee.name }}</p>
        <p class="job-title">{{ attendee.jobTitle }}</p>
      </div>
      <div class="button-wrapper">
        <b-button
          v-if="action === 'Mark'"
          :disabled="attendee.actionInProgress"
          class="text-button"
          style="float: right"
        >
          <font-awesome-icon
            v-if="!attendee.actionInProgress"
            :icon="['fas', 'chevron-right']"
            size="lg"
          />
          <b-spinner v-if="attendee.actionInProgress" small label="Spinning" />
        </b-button>
        <b-button
          v-if="action === 'Unmark'"
          class="text-button"
          style="float: right"
        >
          <font-awesome-icon
            v-if="!attendee.actionInProgress"
            :icon="['fas', 'times']"
            color="#F7685B"
            size="lg"
          />
          <b-spinner v-if="attendee.actionInProgress" small label="Spinning" />
        </b-button>
      </div>
    </b-list-group-item>
  </b-list-group>
</template>

<script>
export default {
  name: "AttendeesEntries",
  props: {
    attendees: { type: Array, required: true },
    action: { type: String, default: "" },
    column: { type: Boolean, default: false },
  },
  methods: {
    borderClassByRole(attendee) {
      return attendee.role.toLowerCase();
    },
    toggleAttending(userId) {
      let attendee = this.attendees.find((a) => a.userId === userId);
      if (attendee.attending) {
        this.$emit("handleRemove", attendee);
      } else {
        this.$emit("handleAdd", attendee);
      }
    },
  },
  computed: {
    checkAction() {
      return this.action !== "";
    },
  },
};
</script>

<style lang="scss" scoped>
.attendees {
  &__attendee {
    display: flex;
    justify-content: flex;
    align-items: center;
    padding-left: 18px;

    .search__results &:first-child {
      // background-color: #ebeced;
      background-color: #f8f9fa;
      // &:before {
      //   content: "(Press Enter)";
      //   position: absolute;
      //   font-size: 12px;
      //   right: 50px;
      //   color: #90a0b7;
      // }
    }
    .company {
      padding: 5px 18px 0 0px;
    }
    .person {
      text-align: left;
    }
    .button-wrapper {
      flex-grow: 1;
    }
  }
}
</style>